import React, { createContext, useContext } from "react";

import { StepAction, StepActionType } from "./Actions";
import { handleSetStepAction } from "./Handlers";

/**
 * The state of the current "step" in the app, which decides which screen is next displayed.
 */
export interface StepState {
    step: number;
}

export const stepInitialState: StepState = {
    step: 0,
};

export const StepStateContext = createContext(stepInitialState);
export const StepDispatchContext = createContext((() => 0) as React.Dispatch<StepAction<any>>);

export const useStepDispatch = () => {
    return useContext(StepDispatchContext);
};

export const useStepState = () => {
    return useContext(StepStateContext);
};

export const stepReducer = (state: StepState, action: StepAction<any>): StepState => {
    switch (action.type) {
        case StepActionType.SetStep:
            return handleSetStepAction(state, action);
        default:
            return state;
    }
};
